import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { catchError, filter, first, map, switchMap } from 'rxjs/operators';
import { asyncScheduler, Observable, scheduled, of } from 'rxjs';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.checkAuth().pipe(
    filter((isAuth): isAuth is boolean => isAuth !== null),
    first(),
    switchMap(isAuth => {
      if (!isAuth) {
        authService.setRedirectUrl(state.url);
        router.navigate(['/login']);
        return of(false);
      }

      return authService.checkPermission(window.location.pathname).pipe(
        map(permission => {
          if (permission.canRead) {
            return true;
          } else {
            router.navigate(['/403']);
            return false;
          }
        }),
        catchError(err => {
          if (err.status === 403) {
            console.error('Error checking permissions:', err);
            router.navigate(['/403']);
          } else if (err.status === 401) {
            console.error('Unauthorized access:', err);
            authService.setRedirectUrl(state.url);
            router.navigate(['/login']);
          } else if (err.status === 404) {
            console.error('Resource not found:', err);
            router.navigate(['/404']);
          }

          return of(false);
        })
      );
    }),
    catchError((err) => {
      console.error('Error checking authentication status:', err);
      authService.setRedirectUrl(state.url);
      router.navigate(['/login']);
      return scheduled([false], asyncScheduler);
    })
  );
};
